import React from 'react';

const PageTitle = ({
  title,
  backgroundColor = '#3b5259',
  children,
  textColor = 'white',
  className = '',
}: {
  title: string;
  backgroundColor?: string;
  textColor?: string;
  children?: React.ReactNode;
  className?: string;
}) => {
  return (
    <div className={`page-title p-4 ${className}`} style={{ backgroundColor }}>
      <h2 className="text-center p-0 m-0" style={{ color: textColor }}>
        {title}
      </h2>
      {children && <>{children}</>}
    </div>
  );
};

export default PageTitle;
